import NameSetting from './NameSetting'
import BasicInfo from './BasicInfo'
import LanguageSetting from './LanguageSetting'
import CurrencySetting from './CurrencySetting'

export default function BasicSettings() {
  return (
    <>
      <NameSetting />
      <BasicInfo />
      <LanguageSetting />
      <CurrencySetting />
    </>
  )
}
